import { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useSSRContext } from "../../../../context/SSRContext";
import { getSelectedSSRItems } from "../../../../utils";
import { formatNumber, formulateName } from "src/utility";

const PassengerSelectionChip: FC<{ passenger: any; isActive: boolean; onClick: () => void }> = ({ passenger, isActive, onClick }) => {
  const { t } = useTranslation();
  const firstName = formulateName(passenger?.firstName);
  const { cursor, getSSRItem } = useSSRContext();
  const ssrItem = getSSRItem(cursor.ssrType, passenger?.value);
  const selectedSSRItems = getSelectedSSRItems(ssrItem);
  const hasSSR = selectedSSRItems.length > 0;
  const totalPrice = selectedSSRItems.reduce((sum, item) => sum + (item.price ?? 0), 0);
  const currency = selectedSSRItems[0]?.currency;
  const subtitle = hasSSR
    ? selectedSSRItems.map((item) => item.code).join(", ")
    : t(`Flights.details.passengerType.${passenger?.type?.toLowerCase()}`);

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "flex min-w-36 shrink-0 cursor-pointer flex-col items-start gap-0.5 rounded-xl px-4 py-2.5 text-start transition-all duration-200 select-none",
        isActive ? "bg-background-primary-lighter ring-border-active ring-2" : "bg-background-default ring-border-default ring-1",
      )}
    >
      <span className="text-14 text-font-default max-w-36 truncate font-semibold">{firstName}</span>
      <span className="text-font-subtle max-w-36 truncate text-xs font-normal">{subtitle}</span>
      {hasSSR && <span className="text-font-active text-xs font-semibold">{`${currency} ${formatNumber(totalPrice)}`}</span>}
    </button>
  );
};

export default PassengerSelectionChip;
